module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp1_8003.ac8fdcda.png";